import {
  DoryMessageType,
  DoryServiceType,
  DoryStreamingHeader,
  DoryStreamingMessage,
} from '../../abstract/StreamingMessages';

function getAlertHeader(messageType: DoryMessageType): DoryStreamingHeader {
  return {
    service: DoryServiceType.ALERT,
    messageType,
    version: 'v1',
  };
}

type AlertSubscribePayload = Record<string, never>;

type AlertPayload = {
  triggerID: string;
  ric: string;
  triggerFid: string;
  triggerValue: number;
  triggerType: string;
  triggerStatus?: string;
  creationDate?: string;
  expirationDate?: string;
  triggerDate?: string;
  info?: string;
};

export { AlertPayload, getAlertHeader };

//#region Subscribe
type AlertSubscribeHeader = {
  messageId?: string;
} & DoryStreamingHeader;

type AlertSubscribeRequest = {
  header: AlertSubscribeHeader;
} & DoryStreamingMessage;

type AlertSubscribeResponse = {
  header: AlertSubscribeHeader;
  payload: {
    status: number;
    message: string;
    subscription: {
      snapshotItems: AlertPayload[];
    };
  };
} & DoryStreamingMessage;

function getAlertSubscribeRequest(): AlertSubscribeRequest {
  return {
    header: getAlertHeader(DoryMessageType.SUBSCRIBE),
  };
}

export {
  AlertSubscribeHeader,
  AlertSubscribeRequest,
  AlertSubscribeResponse,
  AlertSubscribePayload as AlertRequestPayload,
  getAlertSubscribeRequest,
};
//#endregion

//#region Unsubscribe
type AlertUnsubscribeRequest = {
  header: DoryStreamingHeader;
};

type AlertUnsubscribeResponse = {
  header: DoryStreamingHeader;
  payload: {
    status: number;
    message: string;
  };
} & DoryStreamingMessage;

function getAlertUnsubscribeRequest(): AlertUnsubscribeRequest {
  return {
    header: getAlertHeader(DoryMessageType.UNSUBSCRIBE),
  };
}

export {
  AlertUnsubscribeRequest,
  AlertUnsubscribeResponse,
  getAlertUnsubscribeRequest,
};
//#endregion

//#region Update
type AlertUpdateResponse = {
  payload: AlertPayload[];
} & DoryStreamingMessage;

export { AlertUpdateResponse };
//#endregion
